import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { QuixoRules } from './QuixoRules';
export class QuixoHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const state = node.gameState;
        const linesSums = QuixoRules.getLinesSums(state);
        const zerosFullestLine = QuixoRules.getFullestLine(linesSums.get(Player.ZERO));
        const onesFullestLine = QuixoRules.getFullestLine(linesSums.get(Player.ONE));
        return PlayerNumberTable.ofSingle(zerosFullestLine, onesFullestLine);
    }
}
